module.exports = __webpack_public_path__ + "img/lomexin-3.84a1ed01.png";